export class BaseEntity {
  id: number | string;
}
